/// <reference types="./getEntityName.d.ts" />
import { notOk, ok, } from '@dossierhq/core';
import { queryNoneOrOne } from '../QueryFunctions.js';
import { assertIsDefined } from '../utils/AssertUtils.js';
export async function adminEntityGetEntityName(database, context, reference) {
    const result = await queryNoneOrOne(database, context, {
        text: 'SELECT e.name FROM entities e WHERE e.uuid = ?1',
        values: [reference.id],
    });
    if (result.isError())
        return result;
    if (!result.value) {
        return notOk.NotFound('No such entity');
    }
    assertIsDefined(result.value.name);
    return ok(result.value.name);
}
//# sourceMappingURL=getEntityName.js.map